import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToolService } from '../../services/tool';
import { Tool } from '../../models/tool';
import { ToolCard } from '../../components/tool-card/tool-card';

@Component({
  standalone: true,
  selector: 'app-dashboard',
  imports: [CommonModule, FormsModule, ToolCard],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss',
})
export class Dashboard implements OnInit {
  tools: Tool[] = [];
  filteredTools: Tool[] = [];
  search: string = '';
  selectedCategory: string = 'all';
  categories: string[] = [];
  loadError = '';
  loading = true;

  constructor(private toolService: ToolService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.toolService.tools$.subscribe((data: Tool[]) => {
      this.tools = data;
      this.filteredTools = data;
      this.extractCategories();
      this.cdr.markForCheck();
    });

    this.toolService.getTools(true).subscribe({
      next: (data: Tool[]) => {
        this.loadError = '';
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.tools = [];
        this.filteredTools = [];
        this.categories = [];
        this.loadError = 'Unable to load tools from the backend.';
        this.loading = false;
        this.cdr.markForCheck();
      },
    });
  }

  extractCategories(): void {
    const uniqueCategories = [...new Set(this.tools.map((t) => t.category))];
    this.categories = ['all', ...uniqueCategories.sort()];
  }

  filterTools(): void {
    this.filteredTools = this.tools.filter(
      (tool) =>
        (this.selectedCategory === 'all' || tool.category === this.selectedCategory) &&
        tool.name.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  onSearchChange(): void {
    this.filterTools();
  }

  onCategoryChange(): void {
    this.filterTools();
  }
}


